import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { removeFormField, selectAddressFormData, setFormField } from 'slices/addressFormSlice'
import { useAppDispatch } from 'store/hooks'
import {
  EquipmentMatrixBathroom,
  EquipmentMatrixFloorCovering,
  EquipmentMatrixHeating,
  EquipmentMatrixResidentialArea,
  EquipmentMatrixRoofCovering,
  EquipmentMatrixStoreRoom,
  EquipmentMatrixSurfaceMountedInstallation,
  EquipmentMatrixWindows,
  ObjectType,
} from 'types/ApiResponse'
import {
  StyledCol,
  StyledColContainer,
  StyledRowContainer,
} from './ValueEquipmentMatrixForm.styled'
import MultiSelect from 'components/MultiSelect/MultiSelect'
import {
  bathroomEFH,
  bathroomETW,
  fireplaceSelect,
  floorETW,
  guestToilet,
  // heatingSystemSelect,
  heatingType,
  insulatedWalls,
  residentialAreaETW,
  residentialAreaMFH,
  roofCoveringEFHandMFH,
  saunaSelect,
  storeETW,
  storeMFH,
  surfaceMountedInstalationEFH,
  windowsType,
} from '../../helper'
import RadioGroupButtons from 'components/RadioGroupButtons/RadioGroupButtons'

const ValueEquipmentMatrixForm = (props: any) => {
  const { showValidation, validationErrors, setValidationErrors } = props
  const dispatch = useAppDispatch()
  const addressFormData = useSelector(selectAddressFormData)
  const { t } = useTranslation()
  const objectType = addressFormData.addressData?.propertyDetails?.objectType
  // const heatingSystemDisabled =
  //   addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heating !==
  //     EquipmentMatrixHeating.FLOOR_HEATING &&
  //   addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heating !==
  //     EquipmentMatrixHeating.CENTRAL_HEATING

  const validate = (name, property) => {
    if (property === null || property === undefined || property === '') {
      if (!validationErrors.includes(name)) {
        setValidationErrors((errors) => [name, ...errors])
      }
      return showValidation && true
    } else {
      if (validationErrors.includes(name)) {
        setValidationErrors((errors) => errors.filter((error) => error !== name))
      }
      return false
    }
  }

  const validationMultiSelect = (value, options, formFieldName) => {
    if (!options) {
      return value
    }
    const matchingOption = options.find(
      (option) => option.value === `${value}` || option.key === `${value}`
    )
    if (
      (value !== null && value !== undefined && !matchingOption) ||
      value === null ||
      value === undefined
    ) {
      dispatch(removeFormField(formFieldName))
      return false
    }
    return true
  }

  const onChangeGuestToilet = (guestToilet: boolean) => {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMatrix.guestToilet', value: guestToilet })
    )
  }

  const onChangeFireplace = (fireplace: boolean) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.fireplace', value: fireplace }))
  }

  const onChangeSauna = (sauna: boolean) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.sauna', value: sauna }))
  }

  const onChangeInsulatedWalls = (insulatedExteriorWalls: boolean) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.equipmentMatrix.insulatedExteriorWalls',
        value: insulatedExteriorWalls,
      })
    )
  }

  const onChangeSurfaceInstalation = (
    surfaceMountedInstallation: EquipmentMatrixSurfaceMountedInstallation
  ) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.equipmentMatrix.surfaceMountedInstallation',
        value: surfaceMountedInstallation,
      })
    )
  }

  const onChangeHeating = (heating: EquipmentMatrixHeating) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.heating', value: heating }))
    if (
      heating === EquipmentMatrixHeating.STOVES_HEATING ||
      heating === EquipmentMatrixHeating.OTHER
    ) {
      if (
        addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heatingSystem !== undefined
      ) {
        dispatch(removeFormField('propertyDetails.equipmentMatrix.heatingSystem'))
        setValidationErrors((errors) => errors.filter((error) => error !== 'heatingSystem'))
      }
    }
  }

  // const onChangeHeatingSystem = (heatingSystem: boolean) => {
  //   dispatch(
  //     setFormField({ key: 'propertyDetails.equipmentMatrix.heatingSystem', value: heatingSystem })
  //   )
  // }

  const onChangeRoofCovering = (roofCovering: EquipmentMatrixRoofCovering) => {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMatrix.roofCovering', value: roofCovering })
    )
  }

  const onChangeWindows = (windows: EquipmentMatrixWindows) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.windows', value: windows }))
  }

  const onStoreRoomChange = (storeRoom: EquipmentMatrixStoreRoom) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.storeRoom', value: storeRoom }))
  }

  const onFloorChange = (floorCovering: EquipmentMatrixFloorCovering) => {
    dispatch(
      setFormField({ key: 'propertyDetails.equipmentMatrix.floorCovering', value: floorCovering })
    )
  }

  const onChangeBathRoom = (bathroom: EquipmentMatrixBathroom) => {
    dispatch(setFormField({ key: 'propertyDetails.equipmentMatrix.bathroom', value: bathroom }))
  }

  const onChangeOutdoor = (residentialArea: EquipmentMatrixResidentialArea) => {
    dispatch(
      setFormField({
        key: 'propertyDetails.equipmentMatrix.residentialArea',
        value: residentialArea,
      })
    )
  }

  return (
    <>
      <StyledRowContainer>
        <StyledColContainer>
          <StyledCol
            validationError={validate(
              'heating',
              addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heating
            )}
          >
            <MultiSelect
              options={heatingType}
              onChange={(event) => onChangeHeating(event.target.value)}
              label={`${t('newAddressModal.furnishingTab.heatingOptions.label')}*`}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heating}
              validation={validationMultiSelect}
              formFieldName="propertyDetails.equipmentMatrix.heating"
            />
          </StyledCol>
        </StyledColContainer>
        {/* <StyledColContainer $disabled={heatingSystemDisabled}>
          <StyledCol>
            <RadioGroupButtons
              disabled={heatingSystemDisabled}
              validationErrorCheckbox={
                !heatingSystemDisabled &&
                validate(
                  'heatingSystem',
                  addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heatingSystem
                )
              }
              options={heatingSystemSelect}
              label={`${t('newAddressModal.furnishingTab.heatingSystem')}*`}
              onChange={(event) => onChangeHeatingSystem(event.target.value)}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.heatingSystem}
              validation={validationMultiSelect}
              formFieldName="propertyDetails.equipmentMatrix.heatingSystem"
            />
          </StyledCol>
        </StyledColContainer> */}
        {objectType !== ObjectType.APARTMENT && (
          <StyledColContainer>
            <StyledCol
              validationError={validate(
                'roofCovering',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix?.roofCovering
              )}
            >
              <MultiSelect
                options={roofCoveringEFHandMFH}
                onChange={(event) => onChangeRoofCovering(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.roofCovering}
                label={`${t('newAddressModal.furnishingTab.roofOptions.label')}*`}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.roofCovering"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        <StyledColContainer>
          <StyledCol
            validationError={validate(
              'windows',
              addressFormData.addressData?.propertyDetails?.equipmentMatrix?.windows
            )}
          >
            <MultiSelect
              options={windowsType}
              onChange={(event) => onChangeWindows(event.target.value)}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.windows}
              label={`${t('newAddressModal.furnishingTab.windowsOptions.label')}*`}
              validation={validationMultiSelect}
              formFieldName="propertyDetails.equipmentMatrix.windows"
            />
          </StyledCol>
        </StyledColContainer>
        {objectType !== ObjectType.HOUSE && (
          <StyledColContainer>
            <StyledCol
              validationError={validate(
                'storeRoom',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix?.storeRoom
              )}
            >
              <MultiSelect
                options={objectType === ObjectType.APARTMENT ? storeETW : storeMFH}
                onChange={(event) => onStoreRoomChange(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.storeRoom}
                label={`${t('newAddressModal.furnishingTab.storageOptions.label')}*`}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.storeRoom"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        {objectType === ObjectType.APARTMENT && (
          <StyledColContainer>
            <StyledCol
              validationError={validate(
                'floorCovering',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix?.floorCovering
              )}
            >
              <MultiSelect
                options={floorETW}
                onChange={(event) => onFloorChange(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.floorCovering}
                label={`${t('newAddressModal.furnishingTab.floorCoveringOptions.label')}*`}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.floorCovering"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        {objectType !== ObjectType.HOUSE && (
          <StyledColContainer>
            <StyledCol
              validationError={validate(
                'residentialArea',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix?.residentialArea
              )}
            >
              <MultiSelect
                options={
                  objectType === ObjectType.APARTMENT ? residentialAreaETW : residentialAreaMFH
                }
                onChange={(event) => onChangeOutdoor(event.target.value)}
                value={
                  addressFormData.addressData?.propertyDetails?.equipmentMatrix?.residentialArea
                }
                label={`${t('newAddressModal.furnishingTab.outdoorLivingAreaOptions.label')}*`}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.residentialArea"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        {objectType !== ObjectType.MULTI_FAMILY_HOUSE && (
          <StyledColContainer>
            <StyledCol
              validationError={validate(
                'bathroom',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix?.bathroom
              )}
            >
              <MultiSelect
                options={objectType === ObjectType.HOUSE ? bathroomEFH : bathroomETW}
                onChange={(event) => onChangeBathRoom(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.bathroom}
                label={`${t('newAddressModal.furnishingTab.bathOptions.label')}*`}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.bathroom"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        <StyledColContainer>
          <StyledCol>
            <RadioGroupButtons
              validationErrorCheckbox={validate(
                'guestToilet',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix?.guestToilet
              )}
              options={guestToilet}
              label={`${t('newAddressModal.furnishingTab.separateGuestToilet')}*`}
              onChange={(event) => onChangeGuestToilet(event.target.value)}
              value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.guestToilet}
              validation={validationMultiSelect}
              formFieldName="propertyDetails.equipmentMatrix.guestToilet"
            />
          </StyledCol>
        </StyledColContainer>
        <StyledColContainer>
          <StyledCol>
            <RadioGroupButtons
              validationErrorCheckbox={validate(
                'insulatedExteriorWalls',
                addressFormData.addressData?.propertyDetails?.equipmentMatrix
                  ?.insulatedExteriorWalls
              )}
              options={insulatedWalls}
              label={`${t('newAddressModal.furnishingTab.insulatedOuterWalls')}*`}
              onChange={(event) => onChangeInsulatedWalls(event.target.value)}
              value={
                addressFormData.addressData?.propertyDetails?.equipmentMatrix
                  ?.insulatedExteriorWalls
              }
              validation={validationMultiSelect}
              formFieldName="propertyDetails.equipmentMatrix.insulatedExteriorWalls"
            />
          </StyledCol>
        </StyledColContainer>
        {objectType === ObjectType.HOUSE && (
          <StyledColContainer>
            <StyledCol>
              <RadioGroupButtons
                validationErrorCheckbox={validate(
                  'surfaceMountedInstallation',
                  addressFormData.addressData?.propertyDetails?.equipmentMatrix
                    ?.surfaceMountedInstallation
                )}
                options={surfaceMountedInstalationEFH}
                label={`${t('newAddressModal.furnishingTab.linesOnPlaster')}*`}
                onChangeProps={onChangeSurfaceInstalation}
                value={
                  addressFormData.addressData?.propertyDetails?.equipmentMatrix
                    ?.surfaceMountedInstallation
                }
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.surfaceMountedInstallation"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        {objectType === ObjectType.HOUSE && (
          <StyledColContainer>
            <StyledCol>
              <RadioGroupButtons
                validationErrorCheckbox={validate(
                  'fireplace',
                  addressFormData.addressData?.propertyDetails?.equipmentMatrix?.fireplace
                )}
                options={fireplaceSelect}
                label={`${t('newAddressModal.furnishingTab.fireplace')}*`}
                onChange={(event) => onChangeFireplace(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.fireplace}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.fireplace"
              />
            </StyledCol>
          </StyledColContainer>
        )}
        {objectType === ObjectType.HOUSE && (
          <StyledColContainer>
            <StyledCol>
              <RadioGroupButtons
                validationErrorCheckbox={validate(
                  'sauna',
                  addressFormData.addressData?.propertyDetails?.equipmentMatrix?.sauna
                )}
                options={saunaSelect}
                label={`${t('newAddressModal.furnishingTab.sauna')}*`}
                onChange={(event) => onChangeSauna(event.target.value)}
                value={addressFormData.addressData?.propertyDetails?.equipmentMatrix?.sauna}
                validation={validationMultiSelect}
                formFieldName="propertyDetails.equipmentMatrix.sauna"
              />
            </StyledCol>
          </StyledColContainer>
        )}
      </StyledRowContainer>
    </>
  )
}

export default ValueEquipmentMatrixForm
